import { render, staticRenderFns } from "./Datagraph4.vue?vue&type=template&id=14c05ef0&scoped=true"
import script from "./Datagraph4.vue?vue&type=script&lang=js"
export * from "./Datagraph4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c05ef0",
  null
  
)

export default component.exports